import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { T } from 'react-translator-component';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useEffect, useState, useContext, useMemo } from 'react';
import { UserContext } from '../context/user';
import useBookable from '../hooks/useBookable';
import PublicBookableGrid from './PublicBookableGrid';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";

import { useRequests } from "../hooks/useRequests";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { getLocale } from '../functions';
import { usePerson, publicBookablePersonSchema } from '../context/person';


const getTranslation = (key) => T(key);

const GALA_BOOKABLE_DATES = {
    "1b9ebae8-65af-42cf-be20-266e1be88d0d": "2026-12-24",
    "e34040a6-bc3e-4fb0-9957-64a0e947dc11": "2026-12-24",
    "3151b946-ad28-4fe1-b2c2-43fce5770449": "2026-12-24",
    "8f97c239-5137-424e-a4ff-a43867a7d2ea": "2026-12-31",
    "81743ba8-4efc-4550-ac02-1e4373401032": "2026-12-31",
    "b7b790f5-6f86-49c2-8d16-4c146136b5ea": "2026-12-31",
};

const addDaysIso = (isoDate, days) => {
    const [year, month, day] = isoDate.split("-").map(Number);
    const next = new Date(year, month - 1, day + days);
    const mm = String(next.getMonth() + 1).padStart(2, "0");
    const dd = String(next.getDate()).padStart(2, "0");
    return `${next.getFullYear()}-${mm}-${dd}`;
};

const PublicBookableWizard = ({ showDateSelector, setShowDateSelector, handleAddToCart, hotelId, bookableItemId, bookableItemName, showCancel = true, onCancel, setDataReadyToCart, refreshScrollToBottom }) => {

    const { createPublicRequest } = useRequests(hotelId, null, null)
    const { language } = useContext(UserContext);
    const [availableHours, setAvailableHours] = useState([]);
    const [maxQty, setMaxQty] = useState(1);
    const [loading, setLoading] = useState(false);
    const [requestLoading, setRequestLoading] = useState(false);
    const { getScheduleCustom } = useBookable();
    const [schedule, setSchedule] = useState([]);

    const [multiplyPrice, setMultiplyPrice] = useState(false);
    const [allDay, setAllDay] = useState(false);

    const [selectedTotal, setSelectedTotal] = useState(0);
    const [selectedTotalCildren, setSelectedTotalCildren] = useState(0);
    const [selectedRangeDate, setSelectedRangeDate] = useState(null);
    const [selectedRangeHours, setSelectedRangeHours] = useState(1);

    const [comments, setComments] = useState(null);
    const [galaExperience, setGalaExperience] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const galaDate = useMemo(
        () => GALA_BOOKABLE_DATES[bookableItemId] || null,
        [bookableItemId]
    );
    const showGalaExperience = Boolean(galaDate);

    const [errors, setErrors] = useState({});
    const [sendOk, setSendOk] = useState(false);

    const [dateMonth, setDateMonth] = useState(new Date());
    const [date, setDate] = useState(new Date());
    const [highlightedDates, setHighlightedDates] = useState([]);
    const isInputDisabled = useMemo(() => {
        return localStorage.getItem(`ViCo::token-${hotelId}-person`) ? true : false;
    }, [hotelId]);
    const { data: person, setData: setPerson } = usePerson();
    // const [dateHours, setDateHours] = useState('');

    // Obtener la fecha de hoy sin la hora (para comparar correctamente)
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    // 🔹 Fechas destacadas (ejemplo: reuniones o eventos)
    // const highlightedDates = [
    //     // new Date(2025, 2, 10), // 10 de marzo de 2025
    //     // new Date(2025, 2, 15), // 15 de marzo de 2025
    //     // new Date(2025, 2, 20), // 20 de marzo de 2025
    // ];
    // 🔹 Función para agregar clase a días marcados
    const tileClassName = ({ date, view }) => {
        if (view === "month") {
            const isHighlighted = highlightedDates.some(
                (d) => d === date.toISOString().split("T")[0]
            );
            if (isHighlighted) {
                return "highlight-day"; // Clase para días marcados
            }
        }
        return "";
    };


    // 🔹 Verifica si el mes actual es junio (mes 5 en JavaScript)
    const isJuneOrBefore = date.getMonth() <= 5;

    // 🔹 Función que se ejecuta al cambiar de mes
    const handleMonthChange = ({ activeStartDate }) => {
        setDateMonth(activeStartDate); // 🔹 Detecta cambio de mes(setDateMonth); // Guarda el nuevo mes
        console.log("Nuevo mes:", activeStartDate.toISOString().split("T")[0]); // Formato YYYY-MM-DD

        const newYear = activeStartDate.getFullYear();
        const newMonth = activeStartDate.getMonth();
        const firstDayOfMonth = new Date(newYear, newMonth, 1);
        // Si la fecha actual no está dentro del mes mostrado
        if (date.getMonth() !== newMonth || date.getFullYear() !== newYear) {
            // Si el primer día del mes es anterior a hoy, usar hoy
            setDate(firstDayOfMonth < today ? today : firstDayOfMonth);
        }
    };
    // Función para deshabilitar días anteriores a hoy
    const tileDisabled = ({ date, view }) => {
        return view === "month" && date < today; // Deshabilita solo en la vista de mes
    };

    useEffect(() => {
        if (!selectedTotal) return;

        console.log('selectedRangeDate', selectedRangeDate);

        setLoading(true);

        let from;
        let to;
        if (galaDate) {
            from = galaDate;
            to = addDaysIso(galaDate, 1);
        } else {
            const nextMonth = new Date(dateMonth);
            nextMonth.setMonth(nextMonth.getMonth() + 1); // Suma 1 mes
            from = dateMonth.toISOString().split("T")[0];
            to = nextMonth.toISOString().split("T")[0];
        }

        getScheduleCustom(bookableItemId, from, to, 1)
            .then(res => {

                const filteredData = [];
                const noAvailableDates = [];
                res.forEach((day) => {
                    const filteredHours = day.hours.filter((hour) => hour.available >= pax);
                    if (filteredHours.length > 0) {
                        filteredData.push({ date: day.date, hours: filteredHours });
                    } else {
                        noAvailableDates.push(day.date);
                    }
                });
                console.log("📌 Horarios filtrados:", filteredData);
                console.log("📌 Fechas sin horarios disponibles:", noAvailableDates);

                setSchedule(filteredData);
                setHighlightedDates(noAvailableDates);
                //setSchedule(res);
                setLoading(false);

            })


    }, [selectedTotal, selectedTotalCildren, dateMonth, galaDate, bookableItemId])

    const handleSelect = (day, slotHour) => {
        const selected = {
            day: day,
            hour: slotHour,
            coloquialData: `${formatDate(day)} - ${slotHour}${T('general.hs-abrev') != "." ? T('general.hs-abrev') : ''}`
        };
        console.log(selected);
        setSelectedSlot(selected);
    };

    function formatDate(dateString) {
        const date = new Date(dateString + " 10:00:00");

        const dayName = date.toLocaleDateString(language, { weekday: "long" });
        const day = date.getDate();
        const monthName = date.toLocaleDateString(language, { month: "long" });
        const year = date.getFullYear();

        // Capitalizar primera letra del día y mes
        const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

        // Formatos por idioma
        switch (language) {
            case 'es':
            case 'es-ES':
                return `${capitalize(dayName)} ${day} de ${monthName} de ${year}`;
            case 'fr':
            case 'fr-FR':
                return `${capitalize(dayName)} ${day} ${monthName} ${year}`;
            case 'it':
            case 'it-IT':
                return `${capitalize(dayName)} ${day} ${monthName} ${year}`;
            case 'de':
            case 'de-DE':
                return `${capitalize(dayName)} ${day}. ${capitalize(monthName)} ${year}`;
            case 'en':
            case 'en-US':
                return `${capitalize(dayName)}, ${capitalize(monthName)} ${day}, ${year}`;
            default:
                return `${capitalize(dayName)} ${day} ${monthName} ${year}`;
        }
    }

    const handleSend = async () => {
        const personToValidate = {
            fullname: (person?.fullname ?? "").trim(),
            phone: (person?.phone ?? "").trim(),
            email: (person?.email ?? "").trim(),
        };

        const fieldErrors = await validateData(personToValidate);
        if (showGalaExperience && galaExperience !== "yes" && galaExperience !== "no") {
            fieldErrors.galaExperience = "public.bookable.gala-experience.required";
        }
        setErrors(fieldErrors);
        refreshScrollToBottom();
        if (Object.keys(fieldErrors).length > 0) return;

        setLoading(true);
        setRequestLoading(true);

        let personToSend = {
            photo: person?.photo,
            fullname: personToValidate.fullname,
            phone: personToValidate.phone,
            email: personToValidate.email
        }

        let requestData = {
            hotelId: hotelId,
            bookableItemId: bookableItemId,
            bookableItemName: bookableItemName,
            day: selectedSlot.day,
            slot: selectedSlot.hour,
            qty: pax,
            qtyAdults: selectedTotal,
            qtyChildren: selectedTotalCildren,
            Observations: comments,
            client: personToSend,
            origin: "PWA",
            language: language
        };
        if (showGalaExperience) {
            requestData.galaExperience = galaExperience;
        }
        const payload = {
            type: 'public_service',
            data: JSON.stringify(requestData),
        };
        createPublicRequest(payload)
            .then(() => {
                setLoading(false);
                setRequestLoading(false);
                setSendOk(true);
            })
            .catch((error) => {
                console.error("Error creating request:", error);
                setLoading(false);
                setRequestLoading(false);
                setSendOk(false);
            });
    }

    const pax = useMemo(() => {
        return (parseInt(selectedTotal) + parseInt(selectedTotalCildren));
    }, [selectedTotal, selectedTotalCildren]);
    const dateHours = useMemo(() => {
        if (galaDate) return galaDate;
        return date?.toISOString().split("T")[0] || null;
    }, [date, galaDate]);

    useEffect(() => {
        refreshScrollToBottom();
    }, [selectedTotal, date, schedule, loading]);


    // Función para validar los datos
    const validateData = async (data) => {
        const errorMessages = {};
        try {
            await publicBookablePersonSchema.validate(data, { abortEarly: false }); // Validar todo el objeto
            console.log("✅ Datos válidos");
        } catch (error) {
            console.log("❌ Errores de validación:");
            (error.inner || []).forEach((err) => {
                errorMessages[err.path] = err.message;
            });
        }
        return errorMessages;
    };

    if (!schedule) return null;

    return (
        <div style={{ display: showDateSelector ? 'block' : 'none' }} className={`custo__m-modal-container-date d-flex flex-column ${showDateSelector ? 'show' : ''}`}>
            {/* <div className="custom-modal-header-date">
                <h6 className="page-detail-subtitle text-center mt-0 p-2 border-bottom">{T('general.reservation')}</h6>
            </div> */}

            <Form>

                {(!sendOk && !selectedSlot) && (
                    <>
                        <p className='text-center' style={{ fontSize: '14px' }}>{T('public.bookable.init')}</p>

                        <div className="flex-grow-1 d-flex">
                            <div className="custom-modal-body flex-grow-1 d-flex flex-column justify-content-end">
                                <div className="service-booking-form font-size-sm py-1">

                                    <div className='d-flex mb-2 px-2'>

                                        <div className='d-flex w-100'>
                                            <Form.Control
                                                as={"select"}
                                                value={selectedTotal}
                                                placeholder={`${T("checkin.adults")}...`}
                                                className='mb-2'
                                                onChange={(event) => {
                                                    setSelectedTotal(event.target.value)
                                                }}
                                            >
                                                <option value="">{`${T("checkin.adults")}...`}</option>
                                                <option value="1">1 {T("checkin.adult")}</option>
                                                <option value="2">2 {T("checkin.adults")}</option>
                                                <option value="3">3 {T("checkin.adults")}</option>
                                                <option value="4">4 {T("checkin.adults")}</option>
                                                <option value="5">5 {T("checkin.adults")}</option>
                                                <option value="6">6 {T("checkin.adults")}</option>
                                                <option value="7">7 {T("checkin.adults")}</option>
                                                <option value="8">8 {T("checkin.adults")}</option>
                                                <option value="9">9 {T("checkin.adults")}</option>
                                                <option value="10">10 {T("checkin.adults")}</option>
                                            </Form.Control>
                                            <span className='font-size-lg px-1 mr-1' style={{ color: "#F00" }}>*</span>
                                        </div>

                                        <div className='d-flex w-100'>
                                            <Form.Control
                                                as={"select"}
                                                value={selectedTotalCildren}
                                                placeholder={`${T("checkin.children")}...`}
                                                className='mb-2 ml-1'
                                                onChange={(event) => {
                                                    setSelectedTotalCildren(event.target.value)
                                                }}
                                            >
                                                <option value="0">{T("checkin.no-children")}</option>
                                                <option value="1">1 {T("checkin.child")}</option>
                                                <option value="2">2 {T("checkin.children")}</option>
                                                <option value="3">3 {T("checkin.children")}</option>
                                                <option value="4">4 {T("checkin.children")}</option>
                                                <option value="5">5 {T("checkin.children")}</option>
                                                <option value="6">6 {T("checkin.children")}</option>
                                                <option value="7">7 {T("checkin.children")}</option>
                                                <option value="8">8 {T("checkin.children")}</option>
                                                <option value="9">9 {T("checkin.children")}</option>
                                                <option value="10">10 {T("checkin.children")}</option>
                                            </Form.Control>
                                        </div>
                                    </div>

                                    {(!selectedTotal) && (
                                        <div style={{ paddingBottom: "10vh" }}></div>
                                    )}
                                    {selectedTotal != 0 && (

                                        <div className='d-flex justfy-content-center items-align-center mb-2 px-2'>
                                            <div className="bg-white shadow-lg rounded-lg py-2" style={{ border: "1px solid #ced4da" }}>
                                                {!galaDate && (
                                                <Calendar
                                                    locale={getLocale(language).code}

                                                    onChange={setDate}
                                                    value={date}
                                                    className={`custom-calendar ${!selectedTotal && "hidden"}`}

                                                    tileClassName={tileClassName} // Aplica la clase CSS según el criterio
                                                    tileDisabled={tileDisabled} // Deshabilitar días anteriores a hoy

                                                    onActiveStartDateChange={handleMonthChange} // 🔹 Detecta cambio de mes
                                                    nextLabel={isJuneOrBefore ? ">" : null} // 🔹 Oculta ">" después de junio
                                                    prevLabel={"<"} // 🔹 Mantiene el botón de "anterior" visible
                                                    next2Label={null}  // 🔹 Oculta el botón ">>" (década/año siguiente)
                                                    prev2Label={null}  // 🔹 Oculta el botón "<<" (década/año anterior)
                                                />
                                                )}

                                                <div className='mt-2 px-2' style={galaDate ? undefined : { borderTop: "2px solid #EEE" }}>

                                                    {loading && (
                                                        <div className="w-100 text-center my-4 py-4" >
                                                            <div className="loading py-2">
                                                                <div className="spinner-border" role="status">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {!loading && (
                                                        <PublicBookableGrid
                                                            day={dateHours}
                                                            data={schedule}
                                                            paxs={pax}
                                                            language={language}
                                                            handleSelect={handleSelect} />
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </>
                )}



                {(!loading && !sendOk && selectedSlot) && (
                    <div className='px-2 mb-1'>

                        <div className="pb-4 text-center">
                            <div>{T("public.bookable.fill-data")}</div>
                            <div className='mt-2'>
                                <div style={{
                                    background: "#248ea2",
                                    color: "#FFF",
                                    padding: "6px 14px",
                                    borderRadius: 16,
                                    display: "unset"
                                }}>{selectedSlot.coloquialData}</div>
                                <div className='mt-2'>
                                    <button className='btn btn-link' style={{ fontSize: 12 }} onClick={() => setSelectedSlot(null)}>{T("public.edit-hour")}</button>
                                </div>
                            </div>
                        </div>

                        {(!loading && !sendOk) && (
                            <>
                                <div className='mb-2'>
                                    <Form.Control
                                        value={person?.fullname || ""}
                                        placeholder={`${T("public.input.name-and-surname")}...`}
                                        className={`mr-1`}
                                        style={{ border: errors.fullname && "1px solid #dc3545" }}
                                        onChange={(event) => {
                                            setPerson({ ...person, fullname: event.target.value })
                                        }}
                                        //Si hay person token en el localStorage, deshabilitar el input
                                        disabled={isInputDisabled}
                                    ></Form.Control>
                                    {errors.fullname && <p className="pl-2 font-size-sm text-danger">{T(errors.fullname)}</p>}
                                </div>

                                <div className='mb-2'>
                                    <Form.Control
                                        value={person?.phone || ""}
                                        placeholder={`${T("public.input.phone")}...`}
                                        className={`mr-1`}
                                        style={{ border: errors.phone && "1px solid #dc3545" }}
                                        onChange={(event) => {
                                            setPerson({ ...person, phone: event.target.value })
                                        }}
                                        disabled={isInputDisabled}
                                    ></Form.Control>
                                    {errors.phone && <p className="pl-2 font-size-sm text-danger">{T(errors.phone)}</p>}
                                </div>

                                <div className='mb-2'>
                                    <Form.Control
                                        value={person?.email || ""}
                                        placeholder={`${T("public.input.email")}...`}
                                        className={`mr-1`}
                                        style={{ border: errors.email && "1px solid #dc3545" }}
                                        onChange={(event) => {
                                            setPerson({ ...person, email: event.target.value })
                                        }}
                                        disabled={isInputDisabled}
                                    ></Form.Control>
                                    {errors.email && <p className="pl-2 font-size-sm text-danger">{T(errors.email)}</p>}
                                </div>

                                <div className='mb-2'>
                                    <Form.Control
                                        as={"textarea"}
                                        rows={4} // Mínimo 5 líneas visibles
                                        value={comments || ""}
                                        placeholder={`${T("public.input.observations")}...`}
                                        className='mr-1'
                                        onChange={(event) => {
                                            setComments(event.target.value)
                                        }}
                                    ></Form.Control>
                                </div>

                                {showGalaExperience && (
                                    <div className='mb-2'>
                                        <p className="mb-1 font-size-sm">{T("public.bookable.gala-experience")}</p>
                                        <Form.Check
                                            inline
                                            type="radio"
                                            id="gala-experience-yes"
                                            name="galaExperience"
                                            label={T("general.yes")}
                                            checked={galaExperience === "yes"}
                                            onChange={() => {
                                                setGalaExperience("yes");
                                                setErrors((prev) => ({ ...prev, galaExperience: undefined }));
                                            }}
                                        />
                                        <Form.Check
                                            inline
                                            type="radio"
                                            id="gala-experience-no"
                                            name="galaExperience"
                                            label={T("general.no")}
                                            checked={galaExperience === "no"}
                                            onChange={() => {
                                                setGalaExperience("no");
                                                setErrors((prev) => ({ ...prev, galaExperience: undefined }));
                                            }}
                                        />
                                        {errors.galaExperience && (
                                            <p className="pl-2 font-size-sm text-danger">{T(errors.galaExperience)}</p>
                                        )}
                                    </div>
                                )}

                            </>
                        )}

                    </div>
                )}

            </Form>

            {requestLoading && (
                <div className="loading text-center">
                     <div className="spinner-border" role="status"></div>
                </div>
            )}

            {!loading && !sendOk && selectedSlot && (
                <Row className="d-flex align-items-end flex-grow-1 pt-4 px-2">
                    {showCancel && <Col xs={6} style={{ paddingRight: '5px' }}>
                        <Button
                            className='w-100'
                            size={'lg'}
                            variant={'secondary'}
                            type={'button'}
                            onClick={() => {
                                onCancel()
                            }}
                        >
                            {T('general.cancel')}
                        </Button>
                    </Col>}
                    <Col xs={showCancel ? 6 : 12}>
                        <Button
                            className='w-100 btn-booking-book'
                            size={'lg'}
                            variant={'success'}
                            onClick={() => {
                                handleSend();
                            }}
                        >
                            {T('general.reserve')}
                        </Button>
                    </Col>
                </Row>
            )}

            {sendOk && (
                <Container>
                    <Row>
                        <Col className="service-sent text-center">
                        <div className="text-center">
                            <div className="alert" style={{ textAlign: 'center', fontSize: '12px', marginBottom: '0px', background: '#667eea', color: 'white', opacity: 0.9 }}>
                                  {T("public.bookable.sent-text")}
                            </div>
                        </div>
                        </Col>
                    </Row>
                </Container>
            )} 

        </div>
    );
};

export default PublicBookableWizard;
